/**
 * weekly-period-selects
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default sb => {
    let periods;
    let yearSelect;
    let monthSelect;
    let weeksSelect;

    const fetchPeriods = function fetchPeriods() {
        if (periods !== void 0) {
            return Promise.resolve(periods);
        }

        return sb.postApi("/whats-new/top-programmes-available-weeks").then(
            weeks => {
                const dateLocale = "en-GB";
                const monthFormat = "short";

                periods = weeks.reduce((acc, week) => {
                    let [year, month, day] = week.name.split(/-/);

                    year = parseInt(year, 10);
                    month = parseInt(month, 10);
                    day = parseInt(day, 10);

                    acc[year] = acc[year] || {};
                    acc[year][month] = acc[year][month] || {};

                    const end = new Date(year, month - 1, day);
                    const start = new Date(year, month - 1, day - 6);

                    const name = start.getDate() + " " + start.toLocaleString(dateLocale, { month: monthFormat }) +
                        " - " + end.getDate() + " " + end.toLocaleString(dateLocale, { month: monthFormat });

                    acc[year][month][day] = { name, id: week.id };

                    return acc;
                }, {});

                return periods;
            }
        );
    };

    const populatePeriodsSelects = function populatePeriodsSelects(
        yearSelection,
        monthSelection
    ) {
        return fetchPeriods().then(pds => {
            let selectedYear = yearSelection,
                selectedMonth = monthSelection,
                selectedWeek;

            /* If the user has selected a year that isn't this year, select Jan
            for the month, otherwise it will default to the latest month. */
            if (selectedYear && !selectedMonth) {
                if (parseInt(selectedYear, 10) !== (new Date()).getUTCFullYear()) {
                    selectedMonth = 1;
                }
            }

            // Years (in reverse order)
            sb.empty("#period_year")
                .append("#period_year", Object.keys(pds).reverse().map(
                    year => {
                        selectedYear = selectedYear || year;
                        let selected = year === selectedYear ? " selected" : "";
                        return `<option${selected} value="${year}">${year}</option>`;
                    }
                ).join("\n"));

            // Months: reverse to select the most recent month
            const fmt = new Intl.DateTimeFormat("en-GB", {month: "long"});
            const monthOptions = Object.keys(pds[selectedYear]).reverse().map(
                month => {
                    if (selectedMonth === void 0) {
                        selectedMonth = selectedMonth || month;
                    }
                    let selected = selectedMonth === month ? " selected" : "";

                    const monthName = fmt.format(new Date(2015, month - 1, 1));

                    return `<option${selected} value="${month}">${monthName}</option>`;
                }
            );
            // Reverse again so they're displayed chronologically
            sb.empty("#period_month").append(
                "#period_month",
                monthOptions.reverse().join("\n")
            );

            // Weeks: reverse to select the most recent week
            const weekOptions = Object.keys(pds[selectedYear][selectedMonth]).reverse().map(
                day => {
                    let week = pds[selectedYear][selectedMonth][day];
                    if (selectedWeek === void 0) {
                        selectedWeek = week;
                    }
                    let selected = selectedWeek === week ? " selected" : "";
                    return `<option${selected} value=${week.id}>${week.name}</option>`;
                }
            );
            // Reverse again for chronological order
            sb.empty("#period_week").append("#period_week", weekOptions.reverse().join("\n"));

            onWeeksChange(); // We've added periods selected
        });
    };

    const onYearChange = function onYearChange() {
        populatePeriodsSelects(yearSelect[0].value);
    };

    const onMonthChange = function onMonthChange() {
        populatePeriodsSelects(yearSelect[0].value, monthSelect[0].value);
    };

    const onWeeksChange = function onWeeksChange() {
        sb.notify({
            type: "periodsSelectionChanged",
            data: [].map.call(
                getSelectedOptions(weeksSelect[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            yearSelect = sb.find("#period_year");
            monthSelect = sb.find("#period_month");
            weeksSelect = sb.find("#period_week");

            populatePeriodsSelects();

            sb.addEvent(yearSelect, "change", onYearChange);
            sb.addEvent(monthSelect, "change", onMonthChange);
            sb.addEvent(weeksSelect, "change", onWeeksChange);
        },
        destroy() {
            sb.removeEvent(weeksSelect, "change", onWeeksChange);
            sb.removeEvent(monthSelect, "change", onMonthChange);
            sb.removeEvent(yearSelect, "change", onYearChange);

            periods = null;

            yearSelect = null;
            monthSelect = null;
            weeksSelect = null;
        }
    }
}
